export default __webpack_public_path__ + "static/media/instagramIcon.564c1811.jpg";